module.exports = __webpack_public_path__ + "img/eyebrow_female_arched_average.f1f5256a.png";